import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';

import LoadingSpinner from '../../ui/LoadingSpinner';

import app from '../../../app.module.css';
import form from '../../../commonStyles/formStyles.module.css';
import dropdown from '../../../commonStyles/rowExpand.module.css';

const CannotClaimDetails = ({ row, onClose }) => {
    return !row ? (
        <LoadingSpinner content="No cannot claim information found" />
    ) : (
        <div className={`${dropdown.rowDropdown} ${dropdown.redBorder}`} data-testid={'form_start'}>
            <div className={app.sectionHeading}>Cannot Claim Feedback</div>
            <div className={form.staticField}>
                <div className={form.staticText}>{row?.cannotClaimStatusName || ''}</div>
                <div className={form.staticText}>{row?.notes || ''}</div>
            </div>
            <div className={dropdown.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

CannotClaimDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default CannotClaimDetails;
